/** @format */

const template = `
<recommendation
  formal-recommendation="$ctrl.application.decision.formalRecommendation"
  content-recommendation="$ctrl.application.decision.contentRecommendation"
  approval-request-type="$ctrl.application.type"></recommendation>

<div class="row">
  <div class="col-6 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.DECISION</h4>
    <text-with-default-missing-value
      value-key="$ctrl.hasFinalDecision() ? $ctrl.valueKey($ctrl.applicationValue('state'), 'STUDENT_APPLICATIONS.STATE.') : null"
      is-option="true">
    </text-with-default-missing-value>
  </div>
  <div class="col-6 form-group-mimic" ng-if="$ctrl.applicationValue('decision.resolutionRationale')">
    <h4 translate>STUDENT_APPLICATIONS.RESOLUTION_RATIONALE</h4>
    <span class="text-area-static">{{$ctrl.applicationValue('decision.resolutionRationale')}}</span>
  </div>
  <div class="offset-6 col-6 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.DECISION_APPROVER</h4>
    <div
      ><person-name-and-title
        person="$ctrl.applicationValue('decision.approver')"
        title="$ctrl.applicationValue('decision.approverTitle')"></person-name-and-title
    ></div>
  </div>
</div>
<div class="row">
  <div class="col-6 form-group-mimic" ng-if="$ctrl.applicationValue('decision.approvalDate')">
    <h4 translate>STUDENT_APPLICATIONS.APPROVAL_DATE</h4>
    <span>{{$ctrl.applicationValue('decision.approvalDate') | localDateFormat}}</span>
  </div>
  <div class="col-6 form-group-mimic" ng-if="$ctrl.applicationValue('decision.appealInstructions')">
    <sis-markup-string [value]="$ctrl.applicationValue('decision.appealInstructions')">
      <h4 translate>STUDENT_APPLICATIONS.APPEAL_INSTRUCTIONS</h4>
    </sis-markup-string>
  </div>
</div>
<div class="attainment" ng-if="$ctrl.attainment && $ctrl.application.state === STUDENT_APPLICATION_STATE.ACCEPTED">
  <div class="row">
    <div class="col-12 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT</h4>
      <span translate>{{'STUDENT_APPLICATIONS.ATTAINMENT_HAS_BEEN_CREATED.' + $ctrl.attainment.type}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_NAME</h4>
      <span>{{$ctrl.getAttainmentName() | localizedString}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_ADDITIONAL_INFO</h4>
      <span class="text-area-static">{{$ctrl.attainment.additionalInfo | localizedString}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_DATE</h4>
      <span>{{$ctrl.attainment.attainmentDate | localDateFormat}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_CREDITS</h4>
      <span data-cy="attainment-credits">{{$ctrl.attainment.credits | decimalNumber}} {{'CREDITS' | translate}}</span>
    </div>
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_GRADE</h4>
      <span class="text-capitalize">
        {{$ctrl.attainmentGrade.abbreviation | localizedString}} ({{$ctrl.attainmentGrade.name | localizedString}})
      </span>
    </div>
  </div>

  <!-- creditTransferInfo START -->
  <div ng-if="$ctrl.attainment.creditTransferInfo" class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_ORGANISATION</h4>
      <span class="text-capitalize">
        <localized-urn-name-display
          data-cy="attainment-credit-transfer-organisation"
          urn="$ctrl.attainment.creditTransferInfo.educationalInstitutionUrn">
        </localized-urn-name-display>
      </span>
    </div>

    <div ng-if="$ctrl.attainment.creditTransferInfo.internationalInstitutionUrn" class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_FOREIGN_UNI</h4>
      <span class="text-capitalize">
        <localized-urn-name-display
          data-cy="attainment-credit-transfer-international-institution"
          urn="$ctrl.attainment.creditTransferInfo.internationalInstitutionUrn">
        </localized-urn-name-display>
      </span>
    </div>

    <div ng-if="$ctrl.attainment.creditTransferInfo.organisation" class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_FOREIGN_UNI</h4>
      <span class="text-capitalize"> {{ $ctrl.attainment.creditTransferInfo.organisation }} </span>
    </div>
  </div>
  <!-- creditTransferInfo END -->

  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_LANGUAGE</h4>
      <localized-urn-name-display urn="$ctrl.attainment.attainmentLanguageUrn" class="text-capitalize"></localized-urn-name-display>
    </div>
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_STUDY_FIELD</h4>
      <localized-urn-name-display urn="$ctrl.attainment.studyFieldUrn" class="text-capitalize"></localized-urn-name-display>
    </div>
  </div>
  <div class="row" ng-if="!$ctrl.isCourseUnitAttainment()">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_STUDY_LEVEL</h4>
      <localized-urn-name-display data-cy="attainment-study-level" urn="$ctrl.attainment.studyLevelUrn" class="text-capitalize">
      </localized-urn-name-display>
    </div>
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_COURSE_UNIT_TYPE</h4>
      <localized-urn-name-display urn="$ctrl.attainment.courseUnitTypeUrn" class="text-capitalize"></localized-urn-name-display>
    </div>
  </div>
  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_ACCEPTOR_ORGANISATION</h4>
      <span class="text-capitalize acceptor-organisation" ng-repeat="organisation in $ctrl.attainment.organisations">
        <span ng-if="organisation.organisationId"
          >{{$ctrl.attainmentOrganisationsById[organisation.organisationId].name|localizedString}}</span
        >
        <localized-urn-name-display ng-if="!organisation.organisationId" urn="organisation.educationalInstitutionUrn">
        </localized-urn-name-display>
        <span>, </span>
        <localized-urn-name-display urn="organisation.roleUrn"> </localized-urn-name-display>
      </span>
    </div>
  </div>
</div>
`;
export default template;
